import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useShowLiveMapView(): boolean {
  return useCbhFlag(CbhFeatureFlag.SHOULD_SHOW_LIVE_MAP_VIEW, {
    defaultValue: false,
  });
}
